import { View } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';

// Subscribe in the rendered header instead of relying on navigation to
// replace an already-cached headerStyle object when the app theme changes.
export default function PageHeaderBackground() {
    const { theme: { colors } } = useUnistyles();
    return <View testID="page-header-background" pointerEvents="none"
        style={{ flex: 1, backgroundColor: colors.background }} />;
}

export const renderPageHeaderBackground = () => <PageHeaderBackground />;
